import { render, staticRenderFns } from "./CompletedFormsList.vue?vue&type=template&id=2e344a09&scoped=true&lang=pug"
import script from "./CompletedFormsList.vue?vue&type=script&lang=js"
export * from "./CompletedFormsList.vue?vue&type=script&lang=js"
import style0 from "./CompletedFormsList.vue?vue&type=style&index=0&id=2e344a09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e344a09",
  null
  
)

export default component.exports